/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeroBannerData } from './hero-banner.data';
import { IHeroBannerProps } from './hero-banner.props.autogenerated';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export interface IHeroBannerViewProps extends IHeroBannerProps<IHeroBannerData> {}

/**
 *
 * HeroBanner component
 * @extends {React.PureComponent<IHeroBannerProps<IHeroBannerData>>}
 */
class HeroBanner extends React.PureComponent<IHeroBannerProps<IHeroBannerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeroBanner;
